/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Builds_Installoptions_File1Inputs */

const id_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("id", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`file`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`file`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const ms_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ms", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`fail`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`fail`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const da_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("da", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`fil`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`filer`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const de_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Datei`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Dateien`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const en_us2_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en-US", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`file`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`files`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const es_es2_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-ES", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`archivo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`archivos`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const es_mx2_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-MX", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`archivo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`archivos`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const fil_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fil", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`file`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`file`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const fr_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`fichier`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`fichiers`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const it_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("it", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`file`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`file`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const hu_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hu", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`fájl`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`fájl`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const nl_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`bestand`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`bestanden`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const no_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("no", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`fil`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`filer`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const pl_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`plik`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`pliki`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const pt_br2_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`arquivo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`arquivos`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const pt_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`ficheiro`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`ficheiros`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const ro_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ro", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`fișier`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`fișiere`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const fi_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`tiedosto`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`tiedostoa`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const sv_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("sv", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`fil`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`filer`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const vi_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("vi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`tệp`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`tệp`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const tr_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("tr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`dosya`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`dosya`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const cs_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("cs", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`soubor`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`souborů`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const bg_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("bg", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`файл`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`файла`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const ru_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ru", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`файл`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`файлов`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const uk_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("uk", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`файл`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`файли`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const ar_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ar", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`ملف`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`ملفات`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const hi_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`फ़ाइल`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`फ़ाइलें`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const th_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("th", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`ไฟล์`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`ไฟล์`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const ja_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`ファイル`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`ファイル`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const zh_cn2_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-CN", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`文件`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`文件`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const zh_hant1_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-Hant", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`檔案`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`檔案`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

const ko_builds_installoptions_file1 = /** @type {(inputs: Builds_Installoptions_File1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ko", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`파일`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`파일`);
	return /** @type {LocalizedString} */ ("builds.installOptions.file");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "file" |
* | "other" | "files" |
*
* @param {Builds_Installoptions_File1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_installoptions_file1 = /** @type {((inputs: Builds_Installoptions_File1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Installoptions_File1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_installoptions_file1(inputs)
	if (locale === "ms") return ms_builds_installoptions_file1(inputs)
	if (locale === "da") return da_builds_installoptions_file1(inputs)
	if (locale === "de") return de_builds_installoptions_file1(inputs)
	if (locale === "en-US") return en_us2_builds_installoptions_file1(inputs)
	if (locale === "es-ES") return es_es2_builds_installoptions_file1(inputs)
	if (locale === "es-MX") return es_mx2_builds_installoptions_file1(inputs)
	if (locale === "fil") return fil_builds_installoptions_file1(inputs)
	if (locale === "fr") return fr_builds_installoptions_file1(inputs)
	if (locale === "it") return it_builds_installoptions_file1(inputs)
	if (locale === "hu") return hu_builds_installoptions_file1(inputs)
	if (locale === "nl") return nl_builds_installoptions_file1(inputs)
	if (locale === "no") return no_builds_installoptions_file1(inputs)
	if (locale === "pl") return pl_builds_installoptions_file1(inputs)
	if (locale === "pt-BR") return pt_br2_builds_installoptions_file1(inputs)
	if (locale === "pt") return pt_builds_installoptions_file1(inputs)
	if (locale === "ro") return ro_builds_installoptions_file1(inputs)
	if (locale === "fi") return fi_builds_installoptions_file1(inputs)
	if (locale === "sv") return sv_builds_installoptions_file1(inputs)
	if (locale === "vi") return vi_builds_installoptions_file1(inputs)
	if (locale === "tr") return tr_builds_installoptions_file1(inputs)
	if (locale === "cs") return cs_builds_installoptions_file1(inputs)
	if (locale === "bg") return bg_builds_installoptions_file1(inputs)
	if (locale === "ru") return ru_builds_installoptions_file1(inputs)
	if (locale === "uk") return uk_builds_installoptions_file1(inputs)
	if (locale === "ar") return ar_builds_installoptions_file1(inputs)
	if (locale === "hi") return hi_builds_installoptions_file1(inputs)
	if (locale === "th") return th_builds_installoptions_file1(inputs)
	if (locale === "ja") return ja_builds_installoptions_file1(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_installoptions_file1(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_installoptions_file1(inputs)
	return ko_builds_installoptions_file1(inputs)
});
export { builds_installoptions_file1 as "builds.installOptions.file" }